const KEY = "rplaw_timer";
const EVENT = "rplaw-timer-changed";

export function getTimer() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function startTimerStore(timer) {
  localStorage.setItem(KEY, JSON.stringify(timer));
  window.dispatchEvent(new Event(EVENT));
}

export function stopTimerStore() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeTimer(fn) {
  window.addEventListener(EVENT, fn);
  window.addEventListener("storage", fn);
  return () => {
    window.removeEventListener(EVENT, fn);
    window.removeEventListener("storage", fn);
  };
}
